module.exports = __webpack_public_path__ + "static/cortex-value-future-min-edf406cc5751fef4c056cec4ee5cea8e.png";